/* Debug auto-generated by npm run generator */
import { makeStyles, Theme } from "@material-ui/core"
import clsx from "clsx"
import { observer } from "mobx-react"
import MouseTrap from "mousetrap"
import React, { CSSProperties } from "react"
import { useRootClasses } from "style"
import DebugStore from "./DebugStore"

interface DebugProps {
    className?: string
    style?: CSSProperties
}

const useStyles = makeStyles((theme: Theme) => ({
    debugDebugOrganism: {
        width: `100vw`,
        height: `100vh`,
        position: `fixed`,
        left: 0,
        top: 0,
        zIndex: 99999,
        padding: theme.spacing(2),
        background: `rgba(0, 43, 54, 0.5)`,
    },
}))

const Debug: React.FC<DebugProps> = (props) => {
    const classes = useStyles()
    const rootClasses = useRootClasses()
    const className = clsx(classes.debugDebugOrganism, props.className)

    const [show, setShow] = React.useState(false)
    const toggleShow = () => setShow(!show)

    React.useEffect(() => {
        const mouseTrap = new MouseTrap()
        mouseTrap.bind("f7", toggleShow)
        return () => {
            mouseTrap.unbind("f7")
        }
    })

    if (!show) {
        return <></>
    }

    return (
        <div className={className}>
            <h3 className={clsx(rootClasses.colorCommonWhite, rootClasses.ma0)}>Debug Window</h3>
            <DebugStore className={clsx(rootClasses.mt2)} />
        </div>
    )
}

export default observer(Debug)
